import { j as jsxRuntimeExports } from "../../../../react/jsx-runtime.es.js";
import { h as hasOwn, E as Emotion$1, c as createEmotionProps } from "../../dist/emotion-element-43c6fea0.browser.esm.es.js";
import "react";
import "../../../../hoist-non-react-statics/dist/hoist-non-react-statics.cjs.es.js";
import "../../../serialize/dist/emotion-serialize.browser.esm.es.js";
var Fragment = jsxRuntimeExports.Fragment;
function jsx(type, props, key) {
  if (!hasOwn.call(props, "css")) {
    return jsxRuntimeExports.jsx(type, props, key);
  }
  return jsxRuntimeExports.jsx(Emotion$1, createEmotionProps(type, props), key);
}
function jsxs(type, props, key) {
  if (!hasOwn.call(props, "css")) {
    return jsxRuntimeExports.jsxs(type, props, key);
  }
  return jsxRuntimeExports.jsxs(Emotion$1, createEmotionProps(type, props), key);
}
export {
  Fragment,
  jsx,
  jsxs
};
//# sourceMappingURL=emotion-react-jsx-runtime.browser.esm.es.js.map
